import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCommentFilled = () => {
  return (
    <g>
      <path d="m10.2436.93h-4.4873a5.3652 5.3652 0 0 0 0 10.73h1.4937v2.66a.75.75 0 0 0 1.2417.5659l5.5137-4.791c.0137-.0117.0273-.0239.04-.0366a5.3073 5.3073 0 0 0 1.5635-3.7637 5.3712 5.3712 0 0 0 -5.3653-5.3646z" />
    </g>
  );
};

export default withIcon(IconCommentFilled);
